import { forwardRef, memo } from "react";
import { useTranslation } from "react-i18next";
import { NavLink, useLocation } from "react-router";
import { getRouteLocale } from "utils/helpers";

const LocaleNavLink = forwardRef(({ to, children, state = {}, ...restOfProps }, ref) => {
	const { i18n } = useTranslation();
	const { pathname } = useLocation();

	return (
		<NavLink
			to={`${getRouteLocale(i18n.language)}${to}`}
			state={{ from: pathname, ...(state || {}) }}
			ref={ref}
			{...restOfProps}>
			{children}
		</NavLink>
	);
});

export default memo(LocaleNavLink);
